import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Inbox, QrCode, Star, MessageSquareText, Settings as SettingsIcon, LogOut, Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/admin", end: true, label: "Tableau de bord", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/admin/retours", label: "Retours clients", icon: Inbox, testid: "nav-inbox" },
  { to: "/admin/qr-codes", label: "QR codes", icon: QrCode, testid: "nav-qr" },
  { to: "/admin/pagesjaunes", label: "PagesJaunes", icon: Star, testid: "nav-pagesjaunes" },
  { to: "/admin/messages", label: "Messages clients", icon: MessageSquareText, testid: "nav-messages" },
  { to: "/admin/parametres", label: "Paramètres", icon: SettingsIcon, testid: "nav-settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  const Sidebar = () => (
    <div className="flex flex-col h-full">
      <div className="px-5 py-6 border-b border-[#262a33]">
        <div className="font-display text-xl font-extrabold text-white leading-tight">Gestion des avis</div>
        <div className="text-xs text-[#64697a]">CC Auto 30</div>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            onClick={() => setOpen(false)}
            data-testid={l.testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                isActive ? "bg-[#00e676]/10 text-[#00e676]" : "text-[#a0a5b5] hover:bg-[#1e222b] hover:text-white"
              }`
            }
          >
            <l.icon className="w-5 h-5" /> {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-[#262a33]">
        <div className="px-3 py-2 text-xs text-[#64697a] truncate">{user?.email}</div>
        <button onClick={doLogout} data-testid="logout-btn" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-[#a0a5b5] hover:bg-[#1e222b] hover:text-white transition-colors">
          <LogOut className="w-5 h-5" /> Déconnexion
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0a0b0e] text-white flex">
      {/* desktop sidebar */}
      <aside className="hidden lg:block w-64 border-r border-[#262a33] bg-[#0d0f13] fixed h-screen">
        <Sidebar />
      </aside>

      {/* mobile drawer */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-[#0d0f13] border-r border-[#262a33]"><Sidebar /></div>
          <div className="flex-1 bg-black/60" onClick={() => setOpen(false)} />
        </div>
      )}

      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden sticky top-0 z-40 flex items-center justify-between px-4 py-3 bg-[#0a0b0e]/80 backdrop-blur-xl border-b border-[#262a33]">
          <div className="font-display text-xl font-extrabold">CC Auto 30</div>
          <button onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" className="p-2">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </header>
        <main className="p-5 lg:p-8 max-w-6xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
